import React from 'react';
import PropTypes from 'prop-types';
import connectedRouterHOC from '../../utils/connectedRouterHOC';
import ContentContainer from '../contentContainer';
import { showModal } from '../../reducers/modal';
import PageLayout from '../pageLayout';
import { showSuccessNotification, showErrorNotification } from '../../reducers/notifications';
import ProgressClaimCommentTemplatesGrid from './ProgressClaimCommentTemplatesGrid';
import { get, post } from '../../utils/ajax';
import filter from 'lodash/filter';
import { canView } from '../../selectors/canView';
import { canEdit } from '../../selectors/canEdit';
import { getContractId } from '../../selectors/contract';

const ProgressClaimCommentTemplates = props => {
	const [state, setState] = React.useState({
		commentTemplates: [],
		isLoading: false
	});

	React.useEffect(() => {
		setState(prevState => ({ ...prevState, isLoading: true }));
		get({
			url: `/api/progress-claim/comment-templates?contractId=${props.contractId}`,
			onSuccess: data => setState({ commentTemplates: data, isLoading: false }),
			onError: () => setState(prevState => ({ ...prevState, isLoading: false }))
		});
	}, [props.commentTemplateId]);

	const onDeleteProgressClaimCommentTemplate = (commentTemplate) => {
		props.confirmDelete(commentTemplate, () => {
			setState(prevState => ({ ...prevState, isLoading: true }));
			
			post({
				url: `/api/progress-claim/comment-templates/${commentTemplate.progressClaimCommentTemplateId}/delete`,
				onSuccess: data => {
					setState({ isLoading: false, commentTemplates: filter(state.commentTemplates, c => c.progressClaimCommentTemplateId !== commentTemplate.progressClaimCommentTemplateId) });

					if (data.success) {
						props.showSuccessNotification(data.message);
					} else {
						props.showErrorNotification(data.message);
					}
				},
				onError: error => {
					setState(prevState => ({ ...prevState, isLoading: false }));
					props.showErrorNotification(error.message);
				}
			});
		});
	};

	return (
		<PageLayout
			title="Progress Claim - Comment Templates"
			isLoading={state.isLoading}
			actions={
				props.canEdit ? 
				[
					{
						label: 'New Comment Template',
						onClick: () => { props.history.push('/progress-claim/comment-template'); }
					}
				] : []
			}
			content={
				<div>
					<ContentContainer>
						<ProgressClaimCommentTemplatesGrid
							commentTemplates={state.commentTemplates}
							canView={props.canView}
							canEdit={props.canEdit}
							onEditProgressClaimCommentTemplate={commentTemplate => { props.history.push(`/progress-claim/comment-template/${commentTemplate.progressClaimCommentTemplateId}`); }}
							onViewProgressClaimCommentTemplate={commentTemplate => { props.history.push(`/progress-claim/comment-template/${commentTemplate.progressClaimCommentTemplateId}`); }}
							onDeleteProgressClaimCommentTemplate={onDeleteProgressClaimCommentTemplate}
						/>
					</ContentContainer>
				</div>
			}
		/>
    );
};

ProgressClaimCommentTemplates.propTypes = {
	commentTemplateId: PropTypes.number.isRequired,
	canView: PropTypes.bool.isRequired,
	canEdit: PropTypes.bool.isRequired,
	confirmDelete: PropTypes.func.isRequired,
	showSuccessNotification: PropTypes.func.isRequired,
	showErrorNotification: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
	contractId: getContractId(state),
	progressClaimCommentTemplateId: state.context.commentTemplate ? state.context.commentTemplate.progressClaimCommentTemplateId : 0,
	canView: canView(state, 'ViewProgressClaims'),
	canEdit: canEdit(state, 'EditProgressClaims'),
});

const mapDispatchToProps = (dispatch) => ({
	showSuccessNotification: message => dispatch(showSuccessNotification(message)),
	showErrorNotification: message => dispatch(showErrorNotification(message)),
	confirmDelete: (commentTemplate, onOk) => {
		dispatch(showModal('CONFIRM_DELETE', {
			title: 'Delete?',
			message: 'Are you sure you wish to delete this Comment Template?',
			onOk: () => {
				if (onOk) onOk(commentTemplate);
			}
		}));
	}
});

export default connectedRouterHOC(
	mapStateToProps, 
	mapDispatchToProps
)(ProgressClaimCommentTemplates);
